import axios from 'axios';

const handle = async (promise) => {
  try {
    const { data } = await promise;
    return { ok: true, data };
  } catch (err) {
    const data = err?.response?.data || {};
    return {
      ok: false,
      status: err?.response?.status || 0,
      code: data.code || 'NETWORK_ERROR',
      error: data.error || 'Something went wrong. Please check your connection and try again.',
    };
  }
};

// Token-authenticated (public) endpoints
export const fetchPreferencesByToken = (t, view) => handle(axios.get('/mail/preferences', { params: { t, view } }));
export const unsubscribeByToken = (t, scope, extra = {}) => handle(axios.post('/mail/unsubscribe', { t, scope, ...extra }));
export const resubscribeByToken = (t, scope) => handle(axios.post('/mail/resubscribe', { t, scope }));
export const updatePreferencesByToken = (t, categories) => handle(axios.put('/mail/preferences', { t, categories }));
export const requestPreferencesLink = (email) => handle(axios.post('/mail/request-link', { email }));
export const submitUnsubscribeFeedback = (t, reason, reasonText) => handle(axios.post('/mail/feedback', { t, reason, reasonText }));

// Logged-in user endpoints
const authHeaders = (token) => ({ headers: { 'x-access-token': token } });
export const fetchMyPreferences = (token) => handle(axios.get('/user/email-preferences', authHeaders(token)));
export const updateMyPreferences = (token, body) => handle(axios.put('/user/email-preferences', body, authHeaders(token)));

// Bubble Ai admin endpoints
export const adminListSubscriptions = (token, params) => handle(axios.get('/origin/email-subscriptions', { ...authHeaders(token), params }));
export const adminSubscriptionStats = (token) => handle(axios.get('/origin/email-subscriptions/stats', authHeaders(token)));
export const adminSuppressEmail = (token, email, reason) => handle(axios.post('/origin/email-subscriptions/suppress', { email, reason }, authHeaders(token)));
export const adminUnsuppressEmail = (token, email) => handle(axios.post('/origin/email-subscriptions/unsuppress', { email }, authHeaders(token)));
// CSV export goes through axios (not a plain link) because it needs the auth header.
export const adminExportSubscriptionsCsv = (token, params) => handle(axios.get('/origin/email-subscriptions/export.csv', { ...authHeaders(token), params, responseType: 'blob' }));
